// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-container {
  position: absolute;
  left: 45%;
  top: 40%;
  transform: translate(-50%, -50%);
  z-index: 1000000;
}

.spinner-card {
  height: 50px;
  position: relative;
}

.spinner-body {
  position: absolute;
}

.spin-content {
  height: 100px !important;
  width: 100px !important;
  color: #00e1ff;
}

.mogulIn {
  height: 50px;
  width: 50px;
  left: 24px;
  top: 40%;
}

.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  animation-fill-mode: both;
  animation: load7 1.8s infinite ease-in-out;
}

.loader {
  color: #4360AB;
  font-size: 10px;
  z-index: 5000;
  margin: 490px auto;
  position: relative;
  text-indent: -9999em;
  transform: translateZ(0);
  animation-delay: -0.16s;
}
@media (min-width: 300px) {
  .loader {
    margin: 230px auto;
  }
}

.without-margin {
  margin: auto auto;
  margin-bottom: 50px;
}

.loader:before,
.loader:after {
  content: "";
  position: absolute;
  top: 0;
}

.loader:before {
  left: -3.5em;
  animation-delay: -0.32s;
}

.loader:after {
  left: 3.5em;
}
@keyframes load7 {
  0%, 80%, 100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UI/Spinner/Spinner.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;AACF;;AACA;EACE,kBAAA;AAEF;;AAAA;EACE,wBAAA;EACA,uBAAA;EACA,cAAA;AAGF;;AADA;EACE,YAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;AAIF;;AADA;;;EAGE,kBAAA;EACA,YAAA;EACA,aAAA;EAEA,yBAAA;EAEA,0CAAA;AAIF;;AAFA;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EAGA,wBAAA;EAEA,uBAAA;AAKF;AAJE;EAZF;IAaI,kBAAA;EAOF;AACF;;AALA;EACE,iBAAA;EACA,mBAAA;AAQF;;AANA;;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;AASF;;AAPA;EACE,YAAA;EAEA,uBAAA;AAUF;;AARA;EACE,WAAA;AAWF;AAEA;EACE;IAGE,4BAAA;EAOF;EALA;IACE,uBAAA;EAOF;AACF","sourcesContent":[".spinner-container{\r\n  position: absolute;\r\n  left: 45%;\r\n  top: 40%;\r\n  transform: translate(-50%,-50%);\r\n  z-index: 1000000;\r\n}\r\n\r\n.spinner-card {\r\n  height: 50px;\r\n  position: relative;\r\n}\r\n.spinner-body {\r\n  position: absolute;\r\n}\r\n.spin-content{\r\n  height: 100px !important;\r\n  width: 100px !important;\r\n  color: #00e1ff;\r\n}\r\n.mogulIn{\r\n  height: 50px;\r\n  width: 50px;\r\n  left: 24px;\r\n  top: 40%;\r\n\r\n}\r\n.loader,\r\n.loader:before,\r\n.loader:after {\r\n  border-radius: 50%;\r\n  width: 2.5em;\r\n  height: 2.5em;\r\n  -webkit-animation-fill-mode: both;\r\n  animation-fill-mode: both;\r\n  -webkit-animation: load7 1.8s infinite ease-in-out;\r\n  animation: load7 1.8s infinite ease-in-out;\r\n}\r\n.loader {\r\n  color: #4360AB;\r\n  font-size: 10px;\r\n  z-index: 5000;\r\n  margin: 490px auto;\r\n  position: relative;\r\n  text-indent: -9999em;\r\n  -webkit-transform: translateZ(0);\r\n  -ms-transform: translateZ(0);\r\n  transform: translateZ(0);\r\n  -webkit-animation-delay: -0.16s;\r\n  animation-delay: -0.16s;\r\n  @media (min-width: 300px) {\r\n    margin: 230px auto;\r\n  }\r\n}\r\n.without-margin {\r\n  margin: auto auto;\r\n  margin-bottom: 50px;\r\n}\r\n.loader:before,\r\n.loader:after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n}\r\n.loader:before {\r\n  left: -3.5em;\r\n  -webkit-animation-delay: -0.32s;\r\n  animation-delay: -0.32s;\r\n}\r\n.loader:after {\r\n  left: 3.5em;\r\n}\r\n\r\n@-webkit-keyframes load7 {\r\n  0%,\r\n  80%,\r\n  100% {\r\n    box-shadow: 0 2.5em 0 -1.3em;\r\n  }\r\n  40% {\r\n    box-shadow: 0 2.5em 0 0;\r\n  }\r\n}\r\n@keyframes load7 {\r\n  0%,\r\n  80%,\r\n  100% {\r\n    box-shadow: 0 2.5em 0 -1.3em;\r\n  }\r\n  40% {\r\n    box-shadow: 0 2.5em 0 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
